<template>

  <v-card>

    <!-- botonera superior pagina paso 4 asisitente  -->
    <v-toolbar color="white" flat>
      <v-btn icon light>
        <v-icon color="grey darken-2">mdi-domain</v-icon>
      </v-btn>
      <v-toolbar-title class="grey--text text--darken-4">
        {{ $t('resumen') }}
        <p class="caption">{{ $t('pantallaResumen') }}</p>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn color="green darken-1 white--text" value="volver" @click="fVolver()">
        <v-icon>mdi-arrow-left</v-icon>
        <span>{{ $t('volver') }}</span>
      </v-btn>

      <v-btn color="green darken-1 white--text" value="volver" @click="fSaveAndExit()">
        <v-icon>mdi-keyboard-return</v-icon>
        <span>{{ $t('saveAndExit') }}</span>
      </v-btn>

      <v-btn color="green darken-1 white--text" value="pasarPedido" @click="fEnviar()">
        <span>{{ $t('pasarPedido') }}</span>
        <v-icon>mdi-cart</v-icon>
      </v-btn>

    </v-toolbar>

    <!-- visualizador de presupuestos PDF  -->
    <v-card-text id="pdf">
      <iframe :src="dPresupuestoPDF" width="100%" height="700px" title="Presupuestos"></iframe>
    </v-card-text>

    <!-- comprobacion borrado -->
    <v-dialog v-model="dAlertaPaso4Abierta" persistent max-width="370">
      <v-card>
        <v-card-title class="subheading" style="text-align: center; padding: 25px 15px;">{{
          $t('presupuestoPasadoPedido') }}</v-card-title>
        <v-card-actions style="background-color: #eee;padding: 15px">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1  white--text" @click="fSalirAsistente(); dAlertaPaso4Abierta = false">{{
            $t('aceptar') }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div style="flex: 1 1 auto;"></div>
  </v-card>

</template>
<script>

import ShpResumen from './ShpResumen'

// SERVICES
import SrvPres from '@/services/srv-presupuestos'

export default {
  name: 'ShpAsistentePaso3',
  props: {
    pPresupuestoAsistente: {
      type: Object,
      required: true
    }
  },
  components: {
    ShpResumen
  },
  data() {
    return {
      dPresupuestoAsistentePaso4: this.pPresupuestoAsistente,
      dAlertaPaso4Abierta: false,
      dPresupuestoPDF: ''
    }
  },
  methods: {
    fEnviar() {
      this.fAceptarPresupuesto()
    },
    fSalirAsistente() {
      this.$emit('goToListado')
    },
    fVolver() {
      this.$emit('return')
    },
    fSaveAndExit() {
      this.$emit('goToListado')
    },
    fCargarDefault(presupuesto) {
      this.dPresupuestoAsistentePaso4 = presupuesto
      this.fMuestraPresupuestoPDF()
    },
    /*
     * Carga el presupuesto de un WebService
     */
    fMuestraPresupuestoPDF() {
      this.$emit('loading', this.$t('iniImpresPres'))

      const payload = {
        usuario: this.$store.getters.getAutenticacion.usuario,
        tira: this.$store.getters.getAutenticacion.tira,
        empresa: this.$store.getters.getAutenticacion.empresa,
        idPresupuesto: this.dPresupuestoAsistentePaso4.id,
        formato: 'I',
        desformat: 'PDF'
      }

      SrvPres.getImpresionPresupuesto(payload).then(response => {
        if (response.data.statusCode === '200') {
          this.dPresupuestoPDF = response.data.urlEtiqueta
        } else {
          this.$emit('alert', '<b>obtiene url informe</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ') ')
        }
        this.$emit('loading', '')
      }).catch(error => {
        this.fErrorComprobado(error)
        this.$emit('loading', '')
      })
    },
    /*
     * Carga el presupuesto de un WebService
     */
    fAceptarPresupuesto() {
      this.$emit('loading', '')
      const payload = {
        usuario: this.$store.getters.getAutenticacion.usuario,
        tira: this.$store.getters.getAutenticacion.tira,
        empresa: this.$store.getters.getAutenticacion.empresa,
        tipo: '0',
        cliente: this.dPresupuestoAsistentePaso4.cliente,
        numeroPedido: this.dPresupuestoAsistentePaso4.numeroPedido,
        numeroBis: this.dPresupuestoAsistentePaso4.numeroBis
      }
      SrvPres.acceptPresupuesto(payload).then(response => {
        if (response.data.statusCode === '200') {
          this.dAlertaPaso4Abierta = true
        } else {
          this.$emit('alert', '<b>aceptar Presupuesto</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ') ')
        }
        this.$emit('loading', '')
      }).catch(error => {
        this.fErrorComprobado(error)
        this.$emit('loading', '')
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
body {
  font-family: "Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 400;
  overflow-x: hidden;
  overflow-y: auto;
}

html {
  font-size: 10px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.table-responsive {
  min-height: 0.01%;
  overflow-x: auto;
}

.page-header {
  padding-bottom: 9px;
  margin: 10px 0 0px;
  font-size: 22px;
}

.page-header>small {
  color: #666;
  display: block;
  margin-top: 5px;
}

b,
strong {
  font-weight: bold;
}

.address {
  margin-bottom: 20px;
  font-style: normal;
  font-size: 16px;
  line-height: 1.42857143;
  margin-top: 24px;
}

h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  font-family: inherit;
  font-weight: 500;
  line-height: 1.1;
  color: inherit;
}

h1 small,
h2 small,
h3 small,
h4 small,
h5 small,
h6 small,
.h1 small,
.h2 small,
.h3 small,
.h4 small,
.h5 small,
.h6 small,
h1 .small,
h2 .small,
h3 .small,
h4 .small,
h5 .small,
h6 .small,
.h1 .small,
.h2 .small,
.h3 .small,
.h4 .small,
.h5 .small,
.h6 .small {
  font-weight: normal;
  line-height: 1;
  color: #777;
}

h1,
.h1,
h2,
.h2,
h3,
.h3 {
  margin-top: 20px;
  margin-bottom: 10px;
}

h1 small,
.h1 small,
h2 small,
.h2 small,
h3 small,
.h3 small,
h1 .small,
.h1 .small,
h2 .small,
.h2 .small,
h3 .small,
.h3 .small {
  font-size: 65%;
}

small {
  font-size: 80%;
}

small,
.small {
  font-size: 85%;
}

p {
  margin: 0 0 10px;
}

.lead {
  font-size: 16px;
  font-weight: 300;
  line-height: 1.4;
}

.observacionesGenerales {
  color: #777;
  min-height: 20px;
  padding: 19px;
  margin-bottom: 20px;
  background-color: #f5f5f5;
  border: 1px solid #e3e3e3;
}

.text-muted {
  color: #777;
}

.well {
  min-height: 20px;
  padding: 19px;
  margin-bottom: 20px;
  background-color: #f5f5f5;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
}

.well-sm {
  padding: 9px;
  border-radius: 3px;
}

.no-shadow {
  box-shadow: none !important;
}

table {
  border-spacing: 0;
  border-collapse: collapse;
  background-color: transparent;
}

td,
th {
  padding: 0;
}

th {
  text-align: left;
}

.table {
  width: 100%;
  max-width: 100%;
}

.table_th_td {
  padding: 8px;
  line-height: 1.42857143;
  vertical-align: top;
  border-bottom: 1px solid #ddd;
}

.table_th_td_no {
  padding: 8px;
  line-height: 1.42857143;
  vertical-align: top;
  background-color: #ffffff;
  border-bottom: 1px solid #ddd;
}

.table-bordered {
  border: 1px solid #ddd;
}

.table-striped tr:nth-of-type(odd) {
  background-color: #f9f9f9;
}

.obsrvLinea {
  font-size: 11px;
  font-style: italic;
}

.tituloGrupo {
  background-color: #f9f9f9;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Informes/Presupuestos/ShpAsistentePaso4.vue